import {memo} from 'react';

import styled from 'styled-components';

import {Skeleton} from '~/shared/components/Loaders';
import {flexCenter} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {media} from '~/shared/theme/media';

const HeaderBodySkeleton = styled.div`
  height: ${({theme}) => theme.newHeader.height.mobile}px;
  ${({theme}) => media.minLargeMobile`
    height: ${theme.newHeader.height.rest}px;
  `}
  background-color: ${({theme}) => theme.colors.surface};
  ${flexCenter}
`;

const CircleSkeleton = styled(Skeleton)`
  border-radius: 50%;
  margin-left: 16px;
`;

const SkeletonWrapper = styled.div`
  ${flexCenter}
  width: 100%;
  padding: 0 16px;
  ${media.minLargeMobile`
    padding: 0;
    width: 570px;
  `}
  ${media.minLargeTablet`
    width: 1004px;
  `}
  ${media.minLargeDesktop`
    width: 1280px;
  `}
`;

const StyledHighRadiusSkeleton = styled(Skeleton)`
  border-radius: 10px;
  ${flipOnLTR`
    margin-left: 20px;
    ${media.minLargeMobile`
      margin-left: 24px;
    `}
    ${media.minLargeTablet`
      margin-left: 48px;
    `}
    ${media.minLargeDesktop`
      margin-left: 60px;
    `}
  `}
`;

const StyledlowRadiusSkeleton = styled(StyledHighRadiusSkeleton)`
  border-radius: 8px;
  flex-shrink: 0;
`;

const SkeletonGroup = styled.div`
  ${flexCenter}
  ${flipOnLTR`
    margin-right: auto;
    & > *:last-child {
      margin-left: 0;
    }
  `}
`;
const HeaderSkeleton = ({
  isMinLargeMobile,
  isMinLargeTablet,
  isMaxLargeMobile,
}: {
  isMinLargeMobile: boolean;
  isMinLargeTablet: boolean;
  isMaxLargeMobile: boolean;
}) => {
  return (
    <HeaderBodySkeleton>
      <SkeletonWrapper>
        {isMinLargeTablet ? (
          <StyledHighRadiusSkeleton width={108} height={32} />
        ) : (
          <StyledlowRadiusSkeleton width={isMinLargeMobile ? 32 : 24} height={isMinLargeMobile ? 40 : 24} />
        )}
        <StyledHighRadiusSkeleton width={isMinLargeTablet ? 460 : 320} height={20} />
        <SkeletonGroup>
          {isMinLargeMobile && <StyledHighRadiusSkeleton width={98} height={20} />}
          {isMinLargeTablet && <StyledHighRadiusSkeleton width={98} height={20} />}
          {isMinLargeTablet && <StyledHighRadiusSkeleton width={98} height={20} />}
          <CircleSkeleton width={32} height={32} />
          {isMaxLargeMobile && <CircleSkeleton width={32} height={32}/>}
        </SkeletonGroup>
      </SkeletonWrapper>
    </HeaderBodySkeleton>
  );
};

export default memo(HeaderSkeleton);
